import BonusInclusionsLabeledContainer from 'components/Common/Labels/BonusInclusionsLabeledContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { OFFER_TYPE_HOTEL } from 'constants/offer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import React from 'react'

interface Props extends React.PropsWithChildren {
  duration?: number;
  title?: 'bonus' | 'additional'
  offerType: App.OfferType;
}

function AccommodationPackageInclusionsList(props: Props) {
  const {
    children,
    title,
    duration,
    offerType,
  } = props

  const isFlash = offerType === OFFER_TYPE_HOTEL

  if (title === 'bonus' && !isFlash) {
    return <BonusInclusionsLabeledContainer duration={duration}>
      <VerticalSpacer gap={4}>
        {children}
      </VerticalSpacer>
    </BonusInclusionsLabeledContainer>
  }

  return <VerticalSpacer gap={4}>
    {children}
  </VerticalSpacer>
}

export default withOfferPageState((state) => ({
  /**
   * TODO (tmp fix) - at the moment, without optional chaining this breaks with <BundleAndSaveHotelTile /> because
   * it is used in the checkout and is not wrapped at a a higher level with the OfferPageProvider. We need to
   * decide if this is a pattern we want long term or should go with something else
   */
  duration: state?.duration,
  offerType: state?.offer?.type,
}), AccommodationPackageInclusionsList)
